/**
 * PDP delivery-options story, AC9: home delivery is reported free once the SKU's
 * PDP offer price reaches EDD_FREE_SHIPPING_THRESHOLD. Below the threshold no value
 * is returned at all — not `false` — per AC9's explicit contract that the component
 * writes nothing in that case, rather than rendering a "not free" state.
 *
 * Deliberately does not consider quantity, cart contents, category/product
 * exclusions, or the local-delivery condition (159072 AC5) — AC9 reserves those for
 * the cart to resolve and states the comparison here is against the PDP's own
 * offer price alone.
 */
export const resolveFreeShipping = (
	offerPrice: number | undefined,
	freeShippingThreshold: number
): true | undefined =>
	offerPrice !== undefined && offerPrice >= freeShippingThreshold ? true : undefined;
